module.exports = __webpack_public_path__ + "img/social_instagram.534783c4.svg";